import React, { createContext, useState } from 'react'

export const SnackbarContext = createContext()

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [severity, setSeverity] = useState('')
  const [message, setMessage] = useState('')
  const [title, setTitle] = useState('')

  const Snackbar = (newMessage, newSeverity, newTitle) => {
    setOpen(true)
    setSeverity(newSeverity)
    setTitle(newTitle)
    setMessage(newMessage)

    // Automatically close snackbar after 7 seconds
    setTimeout(() => {
      setOpen(false)
    }, 7000)
  }

  const closeSnackbar = () => {
    setOpen(false)
  }

  return (
    <SnackbarContext.Provider
      value={{ open, severity, title, message, Snackbar, closeSnackbar }}
    >
      {children}
    </SnackbarContext.Provider>
  )
}
